<template>
  <div class="row m-0 abs_page"  ref="article">
    <div class="col-12 p-0">
      <div class="row m-0">
        <transition name="fade" mode="out-in">
        <div class="col-12 p-0" v-if="isStatement" key="statement">
          <div class="row m-0">
            <div class="col-12 site_padding">
              <div>
                <div class="post-type-link uppercase cursor" @click="backButton" v-html="postType">
                </div>
                <h1 class="entry-title" v-html="statement.title"></h1>
              </div>
            </div>
          </div>
          <div class="row m-0 justify-content-center">
            <div class="col-10 col-lg-8 entry-content" v-html="statement.content" ref="articleBody"/>
          </div>
          <site-footer></site-footer>
        </div>
        <div class="col-12 p-0" v-else-if="!currentPost" key="archive">
          <div class="row m-0">
            <site-header></site-header>
            <div class="col-12 col-lg-11 site_padding">
              <h1 class="page-title uppercase" v-html="postType"></h1>
              <div class="archive-description cursor" @click="viewStatement">
                <p class="mb-0" v-html="statement.excerpt">
                </p>
                <span class="linkto_description cursor" @click="viewStatement"><span class="nav-next-arrow inline"></span>Read Full research statement</span>
              </div>
              <div class="term-filter" v-if="taxonomies">
                <span class="tax-link cursor" @click="selectCategory('')" :class="{activelink: selectedCategory == ''}">View All</span>
                <span v-for="taxonomy in taxonomies" :key="taxonomy.id" class="tax-link cursor" @click="selectCategory(taxonomy.name)" :class="{activelink: selectedCategory == taxonomy.name}">{{taxonomy.name}}</span>
              </div>
            </div>
          </div>
          <div class="row m-0">
            <div class="col-11 col-sm-10 site_padding pr-0">
              <div class="row m-0 equal">
                <post v-for="(post, index) in filteredPosts" :key="post.id" :post="post" :index="index" @showPost="viewPost"/>
                <!-- <post v-for="post in posts" :key="post.id" :post="post" @showPost="viewPost"/> -->
              </div>
            </div>
          </div>
          <site-footer></site-footer>
        </div>
        <div class="col-12 p-0" v-else key="single">
          <div class="row m-0 justify-content-center">
            <div class="col-12 site_padding">
              <div>
                <div class="post-type-link uppercase cursor" @click="goBack" v-html="postType">
                </div>
                <div class="tax-link" v-for="(category, key) in currentPost.categories_names" :key="key">
                  {{ category }}
                </div>
                <h1 class="entry-title" v-html="currentPost.title.rendered"></h1>
              </div>
            </div>
            <div class="col-12 col-lg-10 text-center" v-if="currentPost.featured_media">
              <img :src="currentPost.featured_image_src" class="img-fluid featured_img">
            </div>
            <div class="col-12 col-lg-10 text-center caption" v-if="currentPost.featured_media">
              <figcaption v-html="currentPost.featured_image_caption"></figcaption>
            </div>
          </div>
          <div class="row m-0 justify-content-center justify-content-md-start">
            <div class="col-10 offset-lg-2 col-lg-8 entry-content pr-22" v-html="currentPost.content.rendered"  ref="articleBody"/>
            <div class="col-lg-2 entry-content pl-lg-0 pr-22 d-none d-lg-flex" v-if="calculated">
              <div class="footnote" v-for="(note, key) in notes" :key="key" :style="{ top: notes[key].top + 'px' }" style="position: absolute" >
                <span>{{key + 1}}. &nbsp;</span>
                <span v-html="note.note"></span>
              </div>
            </div>
            <div class="col-10 entry-content d-lg-none mt-4">
              <div v-if="showAll">
                <div class="footnote mb-1" v-for="(note, key) in notes" :key="key">
                  <span>{{key + 1}}. &nbsp;</span>
                  <span v-html="note.note"></span>
                </div>
                <button @click="showAll = false" class="tax-link mt-3">Show Less</button>
              </div>
              <div v-else>
                <div class="footnote mb-1" v-for="(note, key) in notes.slice(0, 3)" :key="key">
                  <span>{{key + 1}}. &nbsp;</span>
                  <span v-html="note.note"></span>
                </div>
                <button @click="showAll = true" class="tax-link my-3">Show All Footnotes</button>
              </div>
            </div>
            <div class="col-10 entry-content d-lg-none">
              <div class="wp-block-lazyblock-bottom-info d-block">
                <section class="bottom-meta">
                  <div class="meta-values" v-for="(info, key) in infoBlock" :key="key">
                    <h3 class="meta-title">{{info['info-heading']}}</h3>
                    <div v-html="info['info-body']"></div>
                  </div>
                </section>
              </div>
            </div>
          </div>
          <div class="row m-0 my-5" v-if="relatedPost">
            <div class="col-12 offset-lg-2 col-lg-8 entry-content cursor" @click="gotoRelated">
              <div class="row m-0">
                <div class="col-5 col-lg-4 pl-0 pr-22" v-if="relatedPost.featured_image_src">
                  <img :src="relatedPost.featured_image_src" class="img-fluid">
                </div>
                <div class="col-7 col-lg-auto p-0">
                  <h2 class="mt-0">See this project<br/>In <span>{{relatedPost.type}}</span></h2>
                  <span class="nav-next-arrow"></span>
                </div>
              </div>
            </div>
          </div>
          <div class="row mx-0 justify-content-between entry-content previous_next site_padding">
            <div class="col-12 col-md-6 mb-3 mb-md-0 pl-md-0">
              <div class="row m-0 align-items-start cursor" @click="goPrevious" v-if="this.currentPostIdx > 0">
                <div class="col-3 p-0">
                  <div class="nav-previous-arrow"></div>
                </div>
                <div class="col-9 p-0">
                  <h2 v-html="prevPost.title.rendered" class="overflow_text mt-0"></h2>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 pr-md-0">
              <div class="row m-0 align-items-start cursor" @click="goNext" v-if="this.currentPostIdx < this.posts.length-1">
                <div class="col-9 p-0">
                  <h2 v-html="nextPost.title.rendered" class="overflow_text mt-0 text-right"></h2>
                </div>
                <div class="col-3 p-0">
                  <div class="nav-next-arrow"></div>
                </div>
              </div>
            </div>
          </div>
          <site-footer></site-footer>
        </div>
        </transition>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { getPostTaxs, getPostTypes, getPage } from '@/api/wp.js'
export default {
  name: 'Writing',
  props: ['postType', 'isActive', 'taxonomy', 'nav'],
  components: {
    'site-header': () => import('../components/Header.vue'),
    'post': () => import('../components/PostWriting.vue'),
    'site-footer': () => import('../components/Footer.vue')
  },
  data () {
    return {
      calculated: false,
      taxonomies: [],
      isStatement: false,
      sliderIdx: [],
      sliders: [],
      sliderSet: false,
      currentPostIdx: null,
      selectedCategory: null,
      postTypeDetails: {},
      notes: [],
      pageId: 3855,
      statement: {},
      relatedPostId: null,
      showAll: false
    }
  },
  watch: {
    '$route' () {
      this.gotoPost()
    },
    nav () {
      this.currentPostIdx = null
      this.relatedPostId = null
      this.isStatement = false
    },
    writing () {
      this.gotoPost()
    }
  },
  async created () {
    this.getWriting()
    if (this.postType) {
      const posttype = await getPostTypes(this.postType)
      this.postTypeDetails = posttype.data
    }
    if (this.taxonomy) {
      const tax = await getPostTaxs(this.taxonomy)
      this.taxonomies = tax.data
    }
    if (this.pageId) {
      const resp = await getPage(this.pageId)
      this.statement.content = resp.data.content.rendered
      this.statement.title = resp.data.title.rendered
      this.statement.excerpt = resp.data.excerpt.rendered
    }
    this.gotoPost()
  },
  mounted () {
    window.onpopstate = this.backButton
  },
  computed: {
    ...mapGetters(['writing', 'postById']),
    posts () {
      return this.writing
    },
    filteredPosts () {
      if (this.selectedCategory) {
        return this.posts.filter((post) => {
          return post.categories_names.includes(this.selectedCategory)
        })
      } else {
        return this.posts
      }
    },
    currentPost () {
      return this.posts[this.currentPostIdx]
    },
    nextPost () {
      return this.posts[this.currentPostIdx+1]
    },
    prevPost () {
      return this.posts[this.currentPostIdx-1]
    },
    relatedPost () {
      return this.postById(this.relatedPostId)
    }
  },
  methods: {
    ...mapActions(['getWriting']),
    selectCategory ( category ) {
      this.selectedCategory = category
    },
    backButton (event) {
      if (event.state!== null && this.currentPostIdx !== null) {
        this.currentPostIdx = null
        this.relatedPostId = null
        window.onpopstate = null
        history.back()
      } else if (this.isStatement) {
        this.isStatement = false
        window.onpopstate = null
        history.back()
      }
    },
    viewStatement () {
        history.pushState({}, '', '/writing/statement')
        window.onpopstate = this.backButton
        this.isStatement = true
    },
    goBack() {
      this.currentPostIdx = null
      this.sliderSet = false
      this.$router.push('/writing/')
      this.relatedPostId = null
    },
    scrollToTop () {
      this.$el.scrollTop = 0
    },
    setTopOfNotes () {
      setTimeout(()=>{
        if (this.$refs.articleBody && this.notes.length) {
          var tags = this.$refs.articleBody.querySelectorAll("sup.note-marker")
          this.$refs.article.addEventListener('scroll', this.scrolled)
          let i = 0
          let lastTop = 0
          tags.forEach((tag) => {
            let tagtop = tag.offsetTop
            if (tagtop - lastTop < 45) {
              tagtop = lastTop + 45
            }
            lastTop = tagtop
            this.notes[i].top = lastTop
            i+= 1
          })
          this.$forceUpdate()
          this.calculated = true
        }
      },500)
    },
    viewPost(postId){
      this.calculated = false
      if(this.$route.params.article != this.posts[postId].slug) {
        this.$router.push('/writing/' + this.posts[postId].slug)
      }
      this.currentPostIdx = postId
      this.scrollToTop()
      window.onpopstate = this.backButton
      this.relatedPostId = parseInt(this.posts[postId].related_entries[0])
      if (this.posts[postId].notes) {
        this.notes = this.posts[postId].notes
        this.setTopOfNotes()
      }
      if (this.posts[postId].infoblock) {
        this.infoBlock = this.posts[postId].infoblock
      }
      this.setSliderArrows()
    },
    nextImage(idx) {
      this.sliders[idx][this.sliderIdx[idx]].style.opacity = 0
      this.sliderIdx[idx]++
      if (this.sliderIdx[idx] > this.sliders[idx].length - 1) {
        this.sliderIdx[idx] = 0
      }
      this.sliders[idx][this.sliderIdx[idx]].style.opacity = 1
    },
    prevImage(idx) {
      this.sliders[idx][this.sliderIdx[idx]].style.opacity = 0
      this.sliderIdx[idx]--
      if (this.sliderIdx[idx] <= 0) {
        this.sliderIdx[idx] = this.sliders[idx].length - 1
      }
      this.sliders[idx][this.sliderIdx[idx]].style.opacity = 1
    },
    gotoPost() {
      if (typeof this.$route.params.article !== 'undefined') {
        let id = this.posts.findIndex((post)=>{
          return post.slug === this.$route.params.article
        })
        if (id > -1) {
          this.viewPost(id)
        }
      }
    },
    gotoRelated() {
      this.$router.push('/' + this.relatedPost.type + '/' + this.relatedPost.slug)
    },
    goPrevious() {
      if (this.currentPostIdx > 0) {
        this.currentPostIdx = this.currentPostIdx-1
        this.sliderSet = false
        this.viewPost(this.currentPostIdx)
      }
    },
    goNext() {
      if (this.currentPostIdx < this.posts.length-1) {
        this.currentPostIdx = this.currentPostIdx+1
        this.sliderSet = false
        this.viewPost(this.currentPostIdx)
      }
    },
    setSlider(slider, idx){
      this.sliderIdx[idx] = 0
      let sliders = Array.from(slider.children)
      this.sliders[idx] = [...sliders.filter((kid) => kid.tagName !== 'A')]
      slider.getElementsByClassName('next-arrow')[0].onclick = () => {this.nextImage(idx)}
      slider.getElementsByClassName('previous-arrow')[0].onclick = () => {this.prevImage(idx)}
      let arrows = Array.from(slider.getElementsByTagName('figcaption'))
      let i = 1
      arrows.forEach((arrow) => {
        let html = arrow.innerHTML
        arrow.innerHTML = i + "/" +  this.sliders[idx].length + "<br/>" +  html
        i++
      })
    },
    setSliderArrows() {
      if(!this.sliderSet) {
        this.sliderSet = true
        setTimeout(() => {
          let i = 0
          document.querySelectorAll('[id=slider]').forEach((slider) => {
            this.setSlider(slider, i++)
          })
        }, 1000 )
      }
    }
  }
}
</script>
<style scoped>
  /* Enter and leave animations can use different */
  /* durations and timing functions.              */
  .fade-enter-active {
    transition: all .2s ease;
  }
  .fade-leave-active {
    transition: all .2s ease;
  }
  .fade-enter, .fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .equal {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    flex-wrap: wrap;
  }
  .equal > [class*='col-'] {
    display: flex;
    flex-direction: column;
  }
  .nav-next-arrow.inline {
    display: inline-block;
    width: 1em;
    height: 0.7em;
    background-size: contain;
    background-position: center;
    margin: 0 1rem 0 0;
  }
  /* .nav-next-arrow {
    background-image: url(../assets/images/cms-arrow-white.svg);
  }
  .nav-previous-arrow {
    background-image: url(../assets/images/cms-arrow-white.svg);
  } */
  .page-title {
    margin-top: -1rem;
  }
  /*
  .entry-content h2 {
    font-size: 3.75rem;
  }
  .entry-content h2 {
    margin-top: 3.666rem;
    margin-bottom: 2rem;
  } */
  .tax-link:hover {
    color: #ffffff;
    background-color: #000000;
    border-color: #000000;
  }
  .tax-link.activelink {
    color: #ffffff;
    background-color: #000000;
    border-color: #000000;
  }
  .footnote {
    font-size: 14px;
    line-height: 16px;
  }
  @media (min-width: 768px) {
    .nav-next-arrow.inline {
      width: 1em;
      height: 0.75em;
    }
    .footnote {
      font-size: 14px;
      line-height: 16px;
      -webkit-hyphens: auto;
      -moz-hyphens: auto;
      -ms-hyphens: auto;
      hyphens: auto;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      width: calc(100% - 22px);
    }
    .footnote:hover {
      overflow: show;
      text-overflow: none;
      display: block;
      -webkit-line-clamp: none;
      background-color: #ffffff;
      z-index: 9;
    }
    .pr-22 {
      padding-right: 18px;
    }
  }
  @media (min-width: 1440px) {
    .nav-next-arrow.inline {
      width: 1em;
      height: 0.75em;
    }
    .footnote {
      font-size: 16px;
      line-height: 19px;
      -webkit-hyphens: auto;
      -moz-hyphens: auto;
      -ms-hyphens: auto;
      hyphens: auto;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      width: calc(100% - 22px);
    }
    .footnote:hover {
      overflow: show;
      text-overflow: none;
      display: block;
      -webkit-line-clamp: none;
      background-color: #ffffff;
      z-index: 9;
    }
    .pr-22 {
      padding-right: 18px;
    }
  }
</style>